<template>
  <div class="product-item-select" ref="selectWrapper">
    <div role="button" class="product-item-select__trigger" @click.stop="onTriggerClick">
      <div class="product-item-select__title" v-text="modelValue?.text"></div>
      <div class="ap-select__suffix">
        <div class="ap-select__icon">
          <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor"
              d="M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z">
            </path>
          </svg>
        </div>
      </div>
    </div>
    <div class="product-item-select__content" v-show="states.visible">
      <ul ref="refList" class="product-item-select__list" :style="{ minWidth: minWidth }">
        <li class="product-item-select__option"
          :class="[color === modelValue ? 'is-selected' : '', color.enabled ? '' : 'is-disabled', color.value == '-1' ? 'not-available' : '']"
          @mouseenter="onMouseHover" @click.stop="onOptionClick(color)" v-for="color in values" :key="color.value">
          <span>{{ color.text
          }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue';
import type { ProductSpecItem } from '../../types';

interface Props {
  values: ProductSpecItem[],
  modelValue: ProductSpecItem | undefined
}
const prop = withDefaults(defineProps<Props>(), {
  values: () => []
});
const emit = defineEmits(['update:modelValue', 'change'])
const selectWrapper = ref<HTMLElement | null>(null)
const refList = ref<HTMLElement>()
const minWidth = ref('')

const states = reactive({
  visible: false,
});
const hideClose = () => {
  states.visible = false
}
const onMouseHover = () => {
}
const onOptionClick = (item: ProductSpecItem) => {
  if (item.value == '-1') {
    return;
  }
  emit('change', item)
  emit('update:modelValue', item)
  hideClose();
}

const onTriggerClick = (e: MouseEvent) => {
  states.visible = !states.visible
}
let startClick: MouseEvent
const documentHandler = (mouseup: MouseEvent, mousedown: MouseEvent) => {
  //refList
  //selectWrapper
  const mouseUpTarget = mouseup.target as HTMLElement
  const mouseDownTarget = mousedown?.target as HTMLElement
  const isTargetExists = !mouseUpTarget || !mouseDownTarget
  const isContainedByEl =
    selectWrapper.value?.contains(mouseUpTarget) ||
    selectWrapper.value?.contains(mouseDownTarget)

  const isSelf = selectWrapper.value === mouseUpTarget

  // const isTargetExcluded =
  // (excludes.length &&
  //   excludes.some((item) => item?.contains(mouseUpTarget))) ||
  // (excludes.length && excludes.includes(mouseDownTarget as HTMLElement))
  const isContainedByPopper =
    refList.value &&
    (refList.value?.contains(mouseUpTarget) ||
      refList.value?.contains(mouseDownTarget))

  if (isTargetExists || isContainedByEl || isSelf || isContainedByPopper) {
    return
  }

  hideClose()
}

onMounted(() => {
  document.addEventListener(
    'mousedown',
    (e: MouseEvent) => (startClick = e)
  )
  document.addEventListener('mouseup', (e: MouseEvent) => {
    documentHandler(e as MouseEvent, startClick)
  })
})
</script>
<style lang="less">
.product-item-select {
  display: inline-block;
  position: relative;
  vertical-align: middle;
  position: static;
  font-size: 13px;
  min-width: 150px;

  &__trigger {
    border: 1px solid #ccc;
    height: 30px;
    padding: 0 5px 0 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding-left: 10px;
  }

  &__title {
    display: block;
    height: 28px;
    line-height: 28px;
    padding-right: 12px;
    overflow: hidden;
    border: 0;
    background: none;
    outline: none;
    cursor: pointer;
  }

  &__suffix {
    display: inline-flex;
    white-space: nowrap;
    flex-shrink: 0;
    flex-wrap: nowrap;
    height: 100%;
    color: #a8abb2;
    transition: all 0.3s;
    pointer-events: none;
  }

  &__content {}

  &__list {
    margin: 0;
    padding: 0;
    border: 1px solid #ededed;
    border-top: none;
    position: absolute;
    z-index: 500;
    background-color: #fff;
    padding-bottom: 1px;
    visibility: visible;
    max-height: 300px;
    overflow-y: scroll;
  }

  &__option {
    padding: 0 32px 0 10px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #42413e;
    box-sizing: border-box;
    list-style: none;
    cursor: pointer;
    font-size: 13px;
    height: 30px;
    line-height: 30px;

    &.is-selected,
    &:hover {
      background: #1e90ff;
      color: #fff;
    }

    &.is-disabled {
      background: #f5f5f5;
      color: #42413e;

      &:hover {
        cursor: not-allowed;
        color: #999;
        background: #f5f5f5;
      }
    }
  }
}
</style>